import _ from 'lodash'
import type {ParsedStyleItem} from './types'

const propertiesSourceType = {
    THEME: 'theme',
    VALUE: 'value'
}

/**
 * detects font_* and color_* substring in values
 * @param {string | object} value - font or color
 * @returns boolean
 */
const isThemeBasedValue = (value: string | object): boolean => {
    return !!['color_', 'font_'].find(template => _.isString(value) && value.includes(template))
}

const getPropertiesSource = (
    properties: ParsedStyleItem['parsedStyle'][0]['properties']
): ParsedStyleItem['parsedStyle'][0]['propertiesSource'] => {
    return properties.reduce((updatedProperties, property) => {
        const {prop, value, absolutePropName} = property
        const propertySource = isThemeBasedValue(value) ? propertiesSourceType.THEME : propertiesSourceType.VALUE

        return {
            ...updatedProperties,
            [absolutePropName || prop]: propertySource
        }
    }, {})
}

const createPropertiesSource = (styleItems: ParsedStyleItem[]): ParsedStyleItem[] => {
    return styleItems.map(styleItem => {
        const {parsedStyle} = styleItem
        const updatedParsedStyle = Object.entries(parsedStyle).reduce(
            (updatedStyle, [selector, {properties, mobileProperties}]) => {
                return {
                    ...updatedStyle,
                    [selector]: {
                        ...updatedStyle[selector],
                        propertiesSource: {
                            ...getPropertiesSource(properties),
                            ...getPropertiesSource(mobileProperties ?? [])
                        }
                    }
                }
            },
            parsedStyle
        )

        return {
            ...styleItem,
            parsedStyle: updatedParsedStyle
        }
    })
}

export default createPropertiesSource
